import React from "react";
import { Card, Nav, Pagination, Table } from "react-bootstrap";
import { showPageNumbers } from "../../utils/table";
import { TableSkeleton } from "../../skeleton/TableSkeleton";
import Select from "react-select";
import clsx from "clsx";

const itemsPerPageOptions = [
  { label: "10", value: 10 },
  { label: "25", value: 25 },
  { label: "50", value: 50 },
];

const LogsTable = ({
  isLoading,
  columns,
  rows,
  currentPage,
  setCurrentPage,
  totalDocs,
  itemsPerPage,
  setItemsPerPage,
}) => {
  const totalPages = Math.ceil(totalDocs / itemsPerPage);

  return (
    <>
      {isLoading ? (
        <TableSkeleton />
      ) : (
        <Card
          border="light"
          className="table-wrapper shadow-sm"
        >
          <Card.Body className="pt-0">
            <div className="table-responsive" style={{ maxHeight: "600px", overflowY: "auto" }}>
              <Table
                hover
                className="user-table align-items-center table-striped"
              >
                <thead>
                  <tr>
                    {columns.map((col) => (
                      <th
                        key={col.id}
                        className={clsx({
                          "text-center": col.label === "View Details",
                        })}
                        style={{
                          position: "sticky",
                          top: 0,
                          zIndex: 1,
                          backgroundColor: "#fff",
                        }}
                      >
                        {col.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {!rows.length ? (
                    <tr>
                      <td className="bg-grey" colSpan={100}>
                        No Data Found.
                      </td>
                    </tr>
                  ) : (
                    rows?.map((row, index) => (
                      <tr
                        key={row._id}
                        className={index % 2 === 0 ? "even-row" : "odd-row"}
                      >
                        {columns.map((col) => (
                          <td key={col.id}>{row[col.id] ?? "-"}</td>
                        ))}
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </div>
            <Card.Footer className="px-3 border-0 d-lg-flex align-items-center justify-content-between">
              <Nav>
                <Pagination className="mb-2 mb-lg-0">
                  <Pagination.Prev
                    onClick={() =>
                      setCurrentPage((prev) => Math.max(prev - 1, 1))
                    }
                    disabled={currentPage === 1}
                  >
                    Previous
                  </Pagination.Prev>
                  {totalPages > 1 && (
                    <>
                      {totalPages <= 10 ? (
                        // Show all pages if 10 or fewer
                        [...Array(totalPages)].map((_, page) => (
                          <Pagination.Item
                            key={page + 1}
                            active={page + 1 === currentPage}
                            onClick={() => setCurrentPage(page + 1)}
                          >
                            {page + 1}
                          </Pagination.Item>
                        ))
                      ) : (
                        // Show ellipsis for more than 10 pages
                        <>
                          {currentPage > 4 && (
                            <>
                              <Pagination.Item
                                onClick={() => setCurrentPage(1)}
                              >
                                1
                              </Pagination.Item>
                              <Pagination.Ellipsis disabled />
                            </>
                          )}
                          {[...Array(totalPages)].map((_, page) => {
                            if (
                              showPageNumbers(page, currentPage, totalPages)
                            ) {
                              return (
                                <Pagination.Item
                                  key={page + 1}
                                  active={page + 1 === currentPage}
                                  onClick={() => setCurrentPage(page + 1)}
                                >
                                  {page + 1}
                                </Pagination.Item>
                              );
                            }
                            return null;
                          })}
                          {currentPage < totalPages - 3 && (
                            <>
                              <Pagination.Ellipsis disabled />
                              <Pagination.Item
                                onClick={() => setCurrentPage(totalPages)}
                              >
                                {totalPages}
                              </Pagination.Item>
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                  <Pagination.Next
                    onClick={() =>
                      setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                    }
                    disabled={currentPage === totalPages || totalPages === 0}
                  >
                    Next
                  </Pagination.Next>
                </Pagination>
              </Nav>
              <div className="d-flex align-items-center gap-2 mb-2 mb-lg-0">
                <span style={{ fontSize: "14px", whiteSpace: "nowrap" }}>Items per page:</span>
                <div style={{ width: "80px" }}>
                  <Select
                    options={itemsPerPageOptions}
                    value={{ label: String(itemsPerPage), value: itemsPerPage }}
                    onChange={(opt) => {
                      setItemsPerPage(opt.value);
                      setCurrentPage(1);
                    }}
                    menuPlacement="top"
                    isSearchable={false}
                    styles={{
                      control: (base) => ({
                        ...base,
                        minHeight: "30px",
                        height: "30px",
                        fontSize: "12px",
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        padding: "0 6px",
                      }),
                      input: (base) => ({
                        ...base,
                        margin: "0",
                        padding: "0",
                      }),
                      indicatorsContainer: (base) => ({
                        ...base,
                        height: "30px",
                      }),
                    }}
                  />
                </div>
              </div>
            </Card.Footer>
          </Card.Body>
        </Card>
      )}
    </>
  );
};

export default LogsTable;
